<!-- KYMW4402 生協間コピー設定 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">会員生協間コピー設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <h2>コピー元</h2>
          <div class="column-list">
            <!-- 媒体 コピー元 -->
            <label class="list-input-title">媒体</label>
            <div class="list-input-content">
              <input type="text" readonly [value]="model.dspMediumType" [style.width.px]="230"/>
            </div>
            <!-- 受注コード コピー元 -->
            <label class="list-input-title">受注コード</label>
            <div class="list-input-content">
              <input type="text" readonly [value]="model.orderCode" [style.width.rem]="7"/>
            </div>
            <!-- 企画回 コピー元 -->
            <label class="list-input-title">企画回</label>
            <div class="list-input-content">
              <input type="text" readonly [value]="model.catalogId" [style.width.rem]="7"/>
            </div>
            <!-- 会員生協 コピー元 -->
            <label class="list-input-title">会員生協</label>
            <div class="list-input-content">
              <input type="text" readonly [value]="model.dspCoopCode" [style.width.px]="230"/>
            </div>
          </div>
        </div>
        <div>
          <h2>コピー先</h2>
          <div class="element-column">
            <div class="column-list">
              <!-- 媒体 コピー先 -->
              <label class="list-input-title">媒体</label>
              <div class="list-input-content">
                <input type="text" readonly [value]="model.dspMediumType" [style.width.px]="230"/>
              </div>
              <!-- 受注コード コピー先 -->
              <label class="list-input-title">受注コード</label>
              <div class="list-input-content">
                <input type="text" readonly [value]="model.orderCode" [style.width.rem]="7"/>
              </div>
              <!-- 企画回 コピー先 -->
              <label class="list-input-title">企画回</label>
              <div class="list-input-content">
                <input type="text" readonly [value]="model.catalogId" [style.width.rem]="7"/>
              </div>
            </div><!-- div column-list END -->
            <!-- FlexGird -->
            <wj-flex-grid #dtg_CoopList [itemsSource]="model.copyCoopList" [allowDragging]="'None'"
              horizontalScrollPolicy="off" [headersVisibility]="'Column'" [selectionMode]="'Row'"
              verticalScrollPolicy="on" [autoRowHeights]="true" forcedEnabledMode="true" [allowSorting]="false"
              [tabOrder]="0" (initialized)="gridInit(dtg_CoopList)">
              <!-- column チェックボックス -->
              <wj-flex-grid-column [width]="40" [header]="' '" [binding]="'check'" [align]="'center'" [isReadOnly]="true" [minWidth]="5">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" class="selected" [(ngModel)]="cell.item.check" (click)="$event.stopPropagation()"
                    [tabindex]="-1" />
                </ng-template>
              </wj-flex-grid-column>
              <!-- column 会員生協コード -->
              <wj-flex-grid-column [header]="'会員生協コード'" [width]="115" [binding]="'coopCode'" [minWidth]="5"
                [isReadOnly]="true"></wj-flex-grid-column>
              <!-- column 会員生協名 -->
              <wj-flex-grid-column [header]="'会員生協名'" [width]="160" [binding]="'coopName'" [minWidth]="5"
                [isReadOnly]="true"></wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>
      </div><!-- div contents-area END -->
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <!-- button 設定 -->
          <button #btn_Set class="btn-primary" (click)="set()" [tabindex]="0" forcedEnabledMode="true">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>